// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import styles from './index.module.scss';
import { InfoBlock } from 'components/molecules/MyPage/InfoBlock';
import { Field } from 'components/molecules/MyPage/Field';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';
import { useMypageContactInfo } from 'util/hooks/useMypageContactInfo';
import { MyPageType } from 'types/mypage';
import { REGEX_OBJECT } from 'util/ConstantValues';
import Popover from 'components/atoms/Popover';
import { IconInfo } from 'components/atoms/icons/IconInfo';

export const CollectionUserNormal = () => {
  const { t } = useTranslation();
  const user = useSelector(selectUser);
  const hasValidUser = !!user.userId && !!user.role;

  const myPage = useMypageContactInfo<MyPageType.CollectionUserNormal>({
    myPageType: MyPageType.CollectionUserNormal,
    enabled: hasValidUser,
  });

  return (
    <div className={styles.mypage}>
      <div className={styles.generalInfo}>
        <InfoBlock
          className={styles.accountInfo}
          title={t('my_page.account_info.title')}
        >
          <div className={styles.col}>
            <Field
              label={t('my_page.account_info.account_category')}
              value={t('my_page.account_info.collection')}
            />
            <Field
              label={t('my_page.account_info.account_permissions')}
              value={t('my_page.account_info.driver')}
            />
          </div>
        </InfoBlock>
        <InfoBlock
          className={styles.masterInfo}
          title={t('my_page.collection_user_normal.master_info.title')}
        >
          <div className={styles.grid}>
            <Field
              label={t(
                'my_page.collection_user_normal.master_info.company_name'
              )}
              value={myPage.data?.operatorName}
            />
            <Field
              label={t('my_page.collection_user_normal.master_info.site_name')}
              value={myPage.data?.siteName}
            />
            <Field
              label={t(
                'my_page.collection_user_normal.master_info.contact_email'
              )}
              extraLabel={
                <Popover
                  content={t(
                    'my_page.collection_user_normal.master_info.email_tooltip'
                  )}
                  positions={['top']}
                  containerStyle={{
                    whiteSpace: 'pre-wrap',
                  }}
                >
                  <span style={{ display: 'inline-flex' }}>
                    <IconInfo fill="#878787" />
                  </span>
                </Popover>
              }
              value={myPage.data?.email}
              format="email"
              maxLength={100}
              onEdit={(value) =>
                myPage.handleChangeInfo({ email: value, tel: myPage.data?.tel })
              }
            />
            <Field
              label={t(
                'my_page.collection_user_normal.master_info.phone_number'
              )}
              value={myPage.data?.tel}
              format="phone"
              maxLength={15}
              regex={REGEX_OBJECT.number}
              onEdit={(value) =>
                myPage.handleChangeInfo({
                  email: myPage.data?.email,
                  tel: value,
                })
              }
            />
          </div>
        </InfoBlock>
      </div>
    </div>
  );
};
